import React, { FC } from 'react';
import { useTheme, useMergeClasses } from '../../../../../theme';
import { Switch, SwitchProps } from '@shared/ui/Switch';

const SearchFormSwitch: FC<SwitchProps> = ({ classes, ...props }) => {
	const defaultClasses = useTheme('SearchForm').SearchFormSwitch;
	const css = useMergeClasses(defaultClasses, classes);

	return <Switch {...props} classes={css} />;
};

export default SearchFormSwitch;
